import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card-content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerTitle), 1),
      _createElementVNode("img", {
        class: "close-icon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.cancel && this.cancel(...args))),
        src: _ctx.closeIcon,
        alt: "close"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_BottomNavigation, {
      class: "bottom-nav",
      first: true,
      cancel: _ctx.showCancel ? this.cancel : undefined,
      no: this.no,
      yes: this.yes,
      yesText: _ctx.yesText,
      noText: _ctx.noText,
      cancelText: _ctx.cancelText,
      smallMarginRight: true
    }, null, 8, ["cancel", "no", "yes", "yesText", "noText", "cancelText"])
  ]))
}